import { createFileRoute, notFound } from "@tanstack/react-router";
import { i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { getVariant } from "@/tools/youtube-thumbnail/lib/variants";
import { VariantPage } from "@/tools/youtube-thumbnail/pages/VariantPage";

export const Route = createFileRoute("/youtube-thumbnail-downloader/$variant")({
  ssr: true,
  loader: ({ params }) => {
    if (!getVariant(params.variant)) throw notFound();
  },
  head: ({ params }) => {
    const variant = getVariant(params.variant);
    if (!variant) return {};
    return {
      meta: [
        { title: variant.metaTitle() },
        { name: "description", content: variant.metaDescription() },
        { property: "og:title", content: variant.metaTitle() },
        { property: "og:description", content: variant.metaDescription() },
        ...i18nOgMeta(variant.path),
      ],
      links: [...i18nLinks(variant.path)],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: m.yt_breadcrumb_home(),
                item: localeUrl(`/`),
              },
              {
                "@type": "ListItem",
                position: 2,
                name: m.yt_tool_name(),
                item: localeUrl(`/youtube-thumbnail-downloader`),
              },
              {
                "@type": "ListItem",
                position: 3,
                name: variant.navName(),
                item: localeUrl(`${variant.path}`),
              },
            ],
          }),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: variant.faqs.map((f) => ({
              "@type": "Question",
              name: f.q(),
              acceptedAnswer: { "@type": "Answer", text: f.a() },
            })),
          }),
        },
      ],
    };
  },
  component: VariantRoute,
});

function VariantRoute() {
  const { variant } = Route.useParams();
  const def = getVariant(variant);
  if (!def) return null;
  return <VariantPage variant={def} />;
}
